const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/index',
        name: "index",
        meta: {
            title: '后台系统'
        },
        component: () => import('@/layouts/cashier/index.vue'),
        children:[
            {
                // 默认子路由：访问 /index 即首页仪表盘
                path: '',
                name: 'cashier_index',
                meta: { title: '首页', auth: false },
                component: () => import('@/components/cashier/index/dashboard')
            },
            {
                path: '/cashier/userInfo',
                name: 'cashier_user_info',
                meta: { title: '个人中心', auth: false },
                component: () => import('@/components/cashier/userInfo/index')
            },
            {
                path: '/cashier/puxi/index',
                name: 'cashier_puxi_index',
                meta: { title: '谱系', auth: false },
                component: () => import('@/components/cashier/index/index')
            },
            {
                path: '/cashier/puwen/index',
                name: 'cashier_puwen_index',
                meta: { title: '谱文', auth: false },
                component: () => import('@/components/cashier/puwen/index')
            },
            {
                path: '/cashier/pushu/index',
                name: 'cashier_pushu_index',
                meta: { title: '谱书', auth: false },
                component: () => import('@/components/cashier/pushu/index')
            },
            {
                path: '/cashier/manage/index',
                name: 'cashier_manage_index',
                meta: { title: '管理', auth: false },
                component: () => import('@/components/cashier/manage/index')
            },
            {
                path: '/cashier/manage/goods',
                name: 'cashier_manage_goods',
                meta: { title: '商品管理', auth: false },
                component: () => import('@/components/cashier/manage/goods')
            },
            {
                path: '/cashier/manage/order',
                name: 'cashier_manage_order',
                meta: { title: '订单管理', auth: false },
                component: () => import('@/components/cashier/manage/order')
            },
            {
                path: '/cashier/manage/decorate',
                name: 'cashier_manage_decorate',
                meta: { title: '小程序装修', auth: false },
                component: () => import('@/components/cashier/manage/decorate')
            },
            {
                path: '/cashier/manage/news',
                name: 'cashier_manage_news',
                meta: { title: '家谱动态', auth: false },
                component: () => import('@/components/cashier/manage/news')
            },
            {
                path: '/cashier/manage/album',
                name: 'cashier_manage_album',
                meta: { title: '谱系相册', auth: false },
                component: () => import('@/components/cashier/manage/album')
            },
            {
                path: '/cashier/manage/intro',
                name: 'cashier_manage_intro',
                meta: { title: '谱系介绍', auth: false },
                component: () => import('@/components/cashier/manage/intro')
            },
            {
                path: '/cashier/manage/correct',
                name: 'cashier_manage_correct',
                meta: { title: '家谱纠正', auth: false },
                component: () => import('@/components/cashier/manage/correct')
            },
            {
                path: '/cashier/manage/member',
                name: 'cashier_manage_member',
                meta: { title: '成员申请', auth: false },
                component: () => import('@/components/cashier/manage/member')
            },
            {
                path: '/cashier/manage/vip',
                name: 'cashier_manage_vip',
                meta: { title: '会员列表', auth: false },
                component: () => import('@/components/cashier/manage/vip')
            },
            {
                path: '/cashier/manage/vipDetail',
                name: 'cashier_manage_vip_detail',
                meta: { title: '会员明细', auth: false },
                component: () => import('@/components/cashier/manage/vipDetail')
            },
            {
                path: '/cashier/manage/recharge',
                name: 'cashier_manage_recharge',
                meta: { title: '充值记录', auth: false },
                component: () => import('@/components/cashier/manage/recharge')
            },
            {
                path: '/cashier/manage/offering',
                name: 'cashier_manage_offering',
                meta: { title: '祭品', auth: false },
                component: () => import('@/components/cashier/manage/offering')
            },
            {
                path: '/cashier/manage/offeringOrder',
                name: 'cashier_manage_offering_order',
                meta: { title: '祭品订单', auth: false },
                component: () => import('@/components/cashier/manage/offeringOrder')
            },
            {
                path: '/cashier/manage/music',
                name: 'cashier_manage_music',
                meta: { title: '背景音乐', auth: false },
                component: () => import('@/components/cashier/manage/music')
            },
            {
                path: '/cashier/manage/famous',
                name: 'cashier_manage_famous',
                meta: { title: '名人名录', auth: false },
                component: () => import('@/components/cashier/manage/famous')
            },
            {
                path: '/cashier/manage/store',
                name: 'cashier_manage_store',
                meta: { title: '门店管理', auth: false },
                component: () => import('@/components/cashier/manage/store')
            },
            {
                path: '/cashier/manage/account',
                name: 'cashier_manage_account',
                meta: { title: '管理账号', auth: false },
                component: () => import('@/components/cashier/manage/account')
            },
            {
                path: '/cashier/manage/log',
                name: 'cashier_manage_log',
                meta: { title: '日志管理', auth: false },
                component: () => import('@/components/cashier/manage/log')
            },
            {
                path: '/cashier/manage/menu',
                name: 'cashier_manage_menu',
                meta: { title: '后台栏目管理', auth: false },
                component: () => import('@/components/cashier/manage/menu')
            },
            {
                path: '/cashier/manage/protocol',
                name: 'cashier_manage_protocol',
                meta: { title: '协议管理', auth: false },
                component: () => import('@/components/cashier/manage/protocol')
            },
            {
                path: '/cashier/seting/index',
                name: 'cashier_seting_index',
                meta: { title: '基本设置', auth: false },
                component: () => import('@/components/cashier/seting/index')
            }


        ]
    },

    {
        path: '/login',
        name: "index_login",
        meta: {
            title: '总用户登录',
            requireAuth: false
        },
        component: () => import('@/components/cashier/login/index')
    },
    {
        path: '/reg',
        name: "index_reg",
        meta: {
            title: '注册登录页面',
            requireAuth: false
        },
        component: () => import('@/components/cashier/login/reg')
    },
    {
        path: '/findPass',
        name: "index_find_pass",
        meta: {
            title: '找回密码',
            requireAuth: false
        },
        component: () => import('@/components/cashier/login/findPass')
    },



    {
        path: '/404',
        name: "404",
        meta: {
            title: '找不到页面',
            requireAuth: false,
            index: '/404'
        },
        component: () => import('@/components/404/404')
    }
];

export default [...routes]
